import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';

import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';

export function SbSharedControlledHeadingWrapperComponent({ children, itemSearch }) {
    const isSubheaderAvailable = itemSearch?.meta?.subHeader || false;
    if (isSubheaderAvailable) {
        return <HeadingLevel>{Heading => children(Heading)}</HeadingLevel>;
    }

    return children();
}

SbSharedControlledHeadingWrapperComponent.propTypes = {
    isSubHeaderProvided: PropTypes.bool,
    children: PropTypes.func.isRequired,
};

export const SbSharedControlledHeadingWrapper = createFragmentContainer(
    SbSharedControlledHeadingWrapperComponent,
    {
        itemSearch: graphql`
            fragment SbSharedControlledHeadingWrapper_itemSearch on ItemSearchQueryConnection {
                meta {
                    subHeader
                }
            }
        `,
    }
);
